// Copyright (C) 2021 Bystronic Laser AG

export class BendPartCategory {
  static GetEmpty(): BendPartCategory {
    return new BendPartCategory(0, 0, null, null);
  }
  constructor(
    public id: number,
    public tenantId: number,
    public simpleTo: number | null,
    public mediumTo: number | null,
  ) {}
}
